import { IdLabel } from "../../../components/IdLabel/index.js";
import { useReport } from "../hooks/useReport.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Reports/shared/ReportTitle.tsx
function ReportTitle({ id, showId }) {
	const { data } = useReport({ reportId: id || "" }, { cacheStrategy: "cache-only" });
	if (data?.report) return /* @__PURE__ */ jsxs("span", { children: [data.report.title, showId && /* @__PURE__ */ jsxs(Fragment$1, { children: [" ", /* @__PURE__ */ jsx(IdLabel, {
		className: "text-color-subtle font-medium",
		idLabel: data.report.idLabel
	})] })] });
	return null;
}
//#endregion
export { ReportTitle };

//# sourceMappingURL=ReportTitle.js.map